<template>
    <div>
        <v-select :id="`div_`+name"
                  v-model="model_id"
                  :filterable="false"
                  :name="`div_`+name"
                  :options="modelOptions"
                  :reduce="option => option.id"
                  class="style-chooser"
                  label="label"
                  placeholder=""
                  @search="onSearch">
            <template slot="no-options">
                Start typing to search...
            </template>
        </v-select>

        <input :required="required" :id="name" v-model="model_id" :name="name" type="hidden">
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import _ from 'lodash';

export default {
    name: "SelectComponent",
    components: {vSelect},
    props: {
        initialValue: {
            required: false,
            default: 0,
        },
        name: {
            type: String,
            required: true
        },
        urlShow: {
            type: String,
            required: true
        },
        urlSearch: {
            type: String,
            required: true
        },
        changeUrlSite: {
            type: Boolean,
            required: false,
            default: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            model_id: '',
            modelOptions: [],
        }
    },
    watch: {
        model_id: function (value) {
            this.$emit('selectedValue', value)
        }
    },
    methods: {
        async getData() {
            let app = this;
            await axios.get(this.urlShow)
                .then((response) => {
                    app.modelOptions.push(response.data);
                })
                .catch(error => {

                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {

                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);

                })


            this.model_id = parseInt(this.initialValue);

        },
        onSearch(search, loading) {
            loading(true);
            if (search.length) {

                this.search(loading, search, this);
            } else {

                loading(false);
            }
        },
        search: _.debounce((loading, search, vm) => {
            fetch(
                vm.urlSearch + `?search=${escape(search)}`
            ).then(res => {
                res.json().then(json => (vm.modelOptions = json));
                loading(false);
            });
        }, 350),
    },
    mounted() {
        if (this.initialValue > 0) {
            this.getData();
        }
    },
}
</script>

<style>
.vs__dropdown-toggle{
    height: auto;
}
</style>
